define('Components/InstagramWidget/js/views/InstagramCarouselView',[
        'jquery',
        'app',
        'ProductBlockView',
        'underscore',
        'Components/InstagramWidget/js/views/InstagramWidgetInstanceView',
        'InternalLinkView'
    ],
    function ($, app, ProductBlockView, _, InstagramWidgetInstanceView, InternalLinkView) {

        var _DOT_ = '.',
            _INSTAGRAM_WIDGET_ = 'instagram-widget',
            _INSTAGRAM_WIDGET__POST_ = _INSTAGRAM_WIDGET_ + '__post',
            _INSTAGRAM_WIDGET__POST__OVERLAY_ = _INSTAGRAM_WIDGET__POST_ + '__overlay';

        return InstagramWidgetInstanceView.extend({
            name: 'InstagramCarouselView',
            events: {
                'mouseover .instagram-widget__post': 'toggleOverlay',
                'mouseleave .instagram-widget__post': 'toggleOverlay'
            },

            privateSetup:function(){
                this.isSliderAdded = false;
            },

            toggleOverlay: function (e) {
                var visible = e.type === 'mouseover',
                    $el = $(e.currentTarget);
                $el.find(_DOT_ + _INSTAGRAM_WIDGET__POST__OVERLAY_)
                    .not('active')
                    .toggleClass('visible',visible);
            },
            afterRender: function () {
                var view = this;
                view.$('img').one('load', function () {
                    view.$el.addClass('loaded');
                });

                view.listenTo(app, 'scroll', view.lazyLoad);

                setTimeout(function () {
                    if(!view.isSliderAdded) {
                        view.addSlider('.instagram-widget__slider', 1, 20, 500, true);
                        view.isSliderAdded = true;
                    }
                }, 500);

                setTimeout(function () {
                    view.lazyLoad()
                }, 100);

                InternalLinkView.initializeLinksOfView(view);
            },

            /**
             * Create new Siema slider
             * @param {string} selector         The selector to use as a carousel
             * @param {number|Object} perPage   The number of slides to be shown
             * @param {number} threshold        Touch and mouse dragging threshold (in px)
             * @param {number} duration         Slide transition duration in milliseconds
             * @param {boolean} loop            Loop the slides around
             * @returns {undefined}
             */
            addSlider: function (selector, perPage, threshold, duration, loop) {
                var view = this, siemaSlider;
                InstagramWidgetInstanceView.prototype.addSlider.apply(this,arguments);
                siemaSlider = view.siemaSlider;
                view.$('button.instagram-widget__slider__control__btn').on('click', function (e) {
                    var isNext = $(this).is('.next');
                    //console.log(siemaSlider);
                    if(isNext){
                        siemaSlider.next();
                    }else{
                        siemaSlider.prev();
                    }
                });
            }
        })
    });
